export const Skeleton = () => {
  return (
    <div className="mt-6 pb-9">
      <div className="px-6">
        <div className="bg-color-fill size-5 rounded-sm" />
      </div>
      <div className="border-b-color-border border-b px-6 py-4">
        <div className="bg-color-fill h-5 rounded-sm" />
      </div>
      <div className="border-b-color-border border-b px-6 py-4">
        <div className="bg-color-fill h-5 rounded-sm" />
      </div>
      <div className="mt-4 px-6">
        <div className="bg-color-fill size-5 rounded-sm" />
      </div>
      <div className="border-b-color-border border-b px-6 py-4">
        <div className="bg-color-fill h-5 rounded-sm" />
      </div>
      <div className="border-b-color-border border-b px-6 py-4">
        <div className="bg-color-fill h-5 rounded-sm" />
      </div>
    </div>
  );
};
